module.exports = __webpack_public_path__ + "168238242da462ef11f9f5f34168ac65.png";


//////////////////
// WEBPACK FOOTER
// ./assets/images/patches/wings/wave-right-26.png
// module id = 2706
// module chunks = 0